import { TableHead, TableRow, TableBody, TableCell } from '@mui/material';
import { type SecurityAuditEvent } from '../../types';
import AuditTable, {
  HeadTableCell,
  JsonTableCellContent,
  MissingTableCellValue,
  SecondaryTableCell,
} from '../../components/Events/AuditTable';
import moment from 'moment';
import UserInfoTableCell from '../../components/UserInfoTableCell';
import { FormattedMessage } from 'react-intl';

type SecurityAuditEventTableProps = {
  securityAuditEvents: SecurityAuditEvent[];
};

const SecurityAuditEventTable = ({
  securityAuditEvents,
}: SecurityAuditEventTableProps) => (
  <AuditTable>
    <TableHead>
      <TableRow>
        <HeadTableCell width={50}>
          <FormattedMessage id="audit.security_events.events.table.columns.id" />
        </HeadTableCell>
        <HeadTableCell width={100}>
          <FormattedMessage id="audit.security_events.events.table.columns.event_type" />
        </HeadTableCell>
        <HeadTableCell>
          <FormattedMessage id="audit.security_events.events.table.columns.additional_info" />
        </HeadTableCell>
        <HeadTableCell width={150}>
          <FormattedMessage id="audit.security_events.events.table.columns.user" />
        </HeadTableCell>
        <HeadTableCell width={150}>
          <FormattedMessage id="audit.security_events.events.table.columns.origin_ip" />
        </HeadTableCell>
        <HeadTableCell width={120}>
          <FormattedMessage id="audit.security_events.events.table.columns.created_at" />
        </HeadTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {securityAuditEvents.map(securityAuditEvent => (
        <TableRow key={securityAuditEvent.id}>
          <TableCell component="th">#{securityAuditEvent.id}</TableCell>
          <TableCell>{securityAuditEvent.eventType}</TableCell>
          <TableCell>
            {securityAuditEvent.additionalInfo ? (
              <JsonTableCellContent>
                {securityAuditEvent.additionalInfo}
              </JsonTableCellContent>
            ) : (
              <MissingTableCellValue>
                <FormattedMessage id="audit.security_events.events.table.cells.additional_info.missing_value" />
              </MissingTableCellValue>
            )}
          </TableCell>
          <UserInfoTableCell auditEvent={securityAuditEvent} />
          <TableCell>
            <code>{securityAuditEvent.originIp}</code>
          </TableCell>
          <SecondaryTableCell>
            {moment(securityAuditEvent.createdAt).format('L LT')}
          </SecondaryTableCell>
        </TableRow>
      ))}
    </TableBody>
  </AuditTable>
);

export default SecurityAuditEventTable;
